import { useState, useEffect } from "react";
import { safeFetch } from "@/api/safeFetch";
import { Input, ButtonSiguiente, ButtonIconos } from "@/components/ui";
/* import { useNavigate } from "react-router-dom"; */
import { ContratoResultRow } from "@/types/ContratoServiciosProps";
import { useNavigate } from "react-router-dom";

const typeOptions = ["auto", "nombre", "dni", "nie", "cif", "empresa"] as const;

const BuscarContratos: React.FC = () => {
    const [q, setQ] = useState("");
    const [type, setType] = useState<typeof typeOptions[number]>("auto");
    const [results, setResults] = useState<ContratoResultRow[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    /*   const navigate = useNavigate(); */
    const token = localStorage.getItem("token") ?? "";

    useEffect(() => {
        if (!q.trim()) {
            setResults([]);
            return;
        }
        const timer = setTimeout(() => doSearch(), 300);
        return () => clearTimeout(timer);
    }, [q, type]);

    const doSearch = async () => {
        setLoading(true);
        setError(null);

        try {
            const url = `/api/admin/contratos/buscar?q=${encodeURIComponent(q.trim())}&type=${type}`;
            const res = await safeFetch(url, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (!res.ok) throw new Error("Error buscando contratos");

            const data = await res.json();
            setResults(Array.isArray(data) ? data : []);
        } catch (err: any) {
            setError(err.message || "Error inesperado");
            setResults([]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full p-4 h-screen flex items-center justify-center bg-zinc-500 relative py-8">

            {/* 🔙 Botón volver arriba izquierda */}
            <div className="absolute top-4 left-4">
                <ButtonSiguiente
                    onClick={() => navigate("/backoffice")}
                    className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition shadow"
                >
                    ⬅ Volver
                </ButtonSiguiente>
            </div>

            <div className="w-full max-w-3xl bg-zinc-400 dark:text-zinc-700 p-6 rounded-xl shadow-md border-zinc-600 border-r-4 border-t-2 flex flex-col gap-6 shadow-blue-700 h-[calc(90vh-4rem)]">

                <h2 className="text-2xl font-bold text-center">Buscar Contratos</h2>

                {/* Buscador */}
                <div className="w-full bg-blue-600 p-4 rounded-xl flex gap-4 items-center shadow-lg">

                    <div className="flex-1">
                        <label className="text-white block mb-1">Tipo</label>
                        <select
                            value={type}
                            onChange={(e) => setType(e.target.value as any)}
                            className="w-full border-2 border-zinc-600 hover:border-blue-700 p-2 rounded-md h-[36px] dark:bg-white dark:text-zinc-600"
                        >
                            {typeOptions.map((opt) => (
                                <option key={opt} value={opt}>
                                    {opt.toUpperCase()}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex-1">
                        <label className="text-white block mb-1">Buscar</label>
                        <Input
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            placeholder="DNI, NIE, CIF, nombre o empresa..."
                        />
                    </div>

                    <div className="flex-1">
                        <label className="opacity-0 block mb-1">.</label>
                        <ButtonSiguiente onClick={doSearch}>
                            Buscar
                        </ButtonSiguiente>
                    </div>
                </div>

                {loading && <div>Buscando...</div>}
                {error && <div className="text-red-600">{error}</div>}

                {/* Resultados */}
                <div className="flex-1 overflow-y-auto space-y-4">

                    {results.map((r) => (
                        <div key={r.profesional_id} className="bg-white p-4 rounded shadow">

                            <div className="font-semibold text-lg">
                                {r.nombre} {r.apellidos}
                                {r.nombre_empresa && ` — ${r.nombre_empresa}`}
                            </div>

                            <div className="text-sm text-gray-600">
                                {r.dni ?? r.nie ?? r.cif}
                            </div>

                            {/* Lista contratos */}
                            <div className="mt-3 space-y-2 text-zinc-700">
                                {r.contratos.map((c) => (
                                    <div
                                        key={c.contrato_id}
                                        className="flex justify-between items-center bg-gray-100 p-2 rounded"
                                    >
                                        <div>
                                            <div className="font-medium">{c.tipo}</div>
                                            <div className="text-xs text-gray-500">
                                                {new Date(c.fecha_creacion).toLocaleDateString()}
                                            </div>
                                        </div>

                                        <ButtonIconos
                                            onClick={() => window.open(c.download_url, "_blank")}
                                            className="!bg-green-600 text-white text-sm px-4 py-1 rounded items-center whitespace-nowrap shrink-0 !w-auto"
                                        >
                                            Descargar
                                        </ButtonIconos>




                                    </div>
                                ))}
                            </div>

                        </div>
                    ))}

                </div>
            </div>
        </div>
    );
};

export default BuscarContratos;